import * as React from 'react';
import { FilterUserState, SpendingReportState } from '../../../interface/MyInterfaces';
import MapContainer from "../../Common/MapContainer";
import ZoomHelp from './ZoomHelp';
import "./CongressTab.css";
import "./SpendingReportExport.css";
import renderHTML from 'react-render-html';
import { isAgg } from '../../Common/Helpers';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { SpendingReportExportLink, getSpendingReportYearLabel } from './SpendingReportButtonHelpers';

class CongressTab extends React.Component<FilterUserState & SpendingReportState, {}> {
    constructor(props) {
        super(props);
    }

    getOverview() {
        if (this.props.UserState !== undefined && this.props.UserState.username !== undefined && this.props.UserState.username !== "" && this.props.UserState.report_display_id !== undefined && this.props.UserState.report_display_id !== "") {
            let logoUni;
            try {
                logoUni = require(`../../../images/univ_logos/${this.props.UserState.report_display_id}.png`);
            }
            catch (err) {

            }
            return (
                <div>
                    <div className="row">
                        <div className="col-md-9">
                            <h1>{this.props.SpendingReport_Tab2 && this.props.SpendingReport_Tab2.header}</h1>
                            {this.props.UserState.report_display_id == "99007319" && <h2><b style={{ color: "red" }}>Synthetic data for demonstration purposes only</b></h2>}
                            <h3>{this.props.SpendingReport_Tab2 && this.props.SpendingReport_Tab2.sub_header}</h3>
                        </div>
                        <div className="col-md-3">
                            {logoUni &&
                                <img height='80px' src={String(logoUni)} alt='Logo'></img>
                            }
                        </div>
                    </div>
                </div>
            );
        } else {
            return <i className="fa fa-spinner"></i>;
        }
    }

    getMappedPercent() {
        if (this.props.SpendingReport_Tab2 !== undefined) {
            return this.props.SpendingReport_Tab2.footer_text;
        }
        return <i className="fa fa-spinner"></i>;
    }

    spendingText() {
        if (this.props.SpendingReport_Tab2 && this.props.SpendingReport_Tab2.chart1_text && this.props.SpendingReport_Tab2.chart1_text != "") {
            var chart_text = renderHTML(this.props.SpendingReport_Tab2.chart1_text);
            return chart_text;
        }
        return <div>loading <i className="fa fa-spinner"></i></div>
    }
    spendingStateText() {
        if (this.props.SpendingReport_Tab2 && this.props.SpendingReport_Tab2.chart2_text && this.props.SpendingReport_Tab2.chart2_text != "") {
            var chart_text = renderHTML(this.props.SpendingReport_Tab2.chart2_text);
            return chart_text;
        }
        return <div>loading <i className="fa fa-spinner"></i></div>
    }

    public render() {
        const agg = isAgg(this.props.UserState.report_display_id);
        const isStateAgg = this.props.SpendingReportConf ? this.props.SpendingReportConf.state_fips : 0;
        const yearLabel = getSpendingReportYearLabel(this.props.FilterState.start_year, this.props.FilterState.end_year);
        return <div className='tabcontents container-fluid'>
            {this.getOverview()}
            <div className="row">
                <div className="chartcontainer congressmap1 spending-chart-export-container" style={{paddingLeft:"15px"}}>
                    <h4>National Distribution of Research-Related Expenditures</h4>
                    <p>The production of science requires the purchase of scientific equipment and technology as well as collaboration with private/public research organizations.</p>

                    {this.spendingText()}

                    <div className="spending-chart-toolbar spending-chart-toolbar--congress">
                        <SpendingReportExportLink targetId="spending-export-target-5" fileName={`congress-map-national-fy-${yearLabel}.png`} />
                        <ZoomHelp className="zoomhelpcongressmap" chart_no={5} />
                    </div>
                    <div id="spending-export-target-5" className="spending-export-block spending-export-block--map spending-export-block--congress">
                    <h5 className="h5_bigger congress-map-title">{this.props.SpendingReport_Tab2 && this.props.SpendingReport_Tab2.chart1_chart_title}</h5>
                    {

                        (this.props.SpendingReportConf && this.props.SpendingCongressMap && this.props.USStateList)
                                ? <MapContainer
                                    agg={agg}
                                    isInState={false}
                                    isZoomed={false}
                                    isCongress={true}
                                    state_fips={this.props.SpendingReportConf.state_fips}
                                    mapData={this.props.SpendingCongressMap}
                                    USState={this.props.USStateList}
                            />

                            : <div>loading <i className="fa fa-spinner"></i></div>
                    }
                    </div>



                </div>
            </div>
            {agg && !isStateAgg ? null :   //non-state level aggregation combined chart2 with chart1
                <div className="row">
                    <div className="chartcontainer congressmap1 spending-chart-export-container" style={{ paddingLeft: "15px" }}>
                        <h4>Regional Distribution of Research-Related Expenditures</h4>
                        {this.spendingStateText()}
                        <div className="spending-chart-toolbar spending-chart-toolbar--congress">
                            <SpendingReportExportLink targetId="spending-export-target-6" fileName={`congress-map-regional-fy-${yearLabel}.png`} />
                            <ZoomHelp className="zoomhelpcongressmap" chart_no={6} />
                        </div>
                        <div id="spending-export-target-6" className="spending-export-block spending-export-block--map spending-export-block--congress">
                            <h5 className="h5_bigger congress-map-title">{this.props.SpendingReport_Tab2 && this.props.SpendingReport_Tab2.chart2_chart_title}</h5>
                            {

                                (this.props.SpendingReportConf && this.props.SpendingCongressMap && this.props.USStateList)
                                    ? <MapContainer
                                        agg={agg}
                                        isInState={true}
                                        isZoomed={false}
                                        isCongress={true}
                                        state_fips={this.props.SpendingReportConf.state_fips}
                                        mapData={this.props.SpendingCongressMap}
                                        USState={this.props.USStateList}
                                    />
                                    : <div>loading <i className="fa fa-spinner"></i></div>
                         
                            }
                        </div>
                    </div>
                </div>}
            <div className='row'>
                <div className="col-md-12">
                    <p>*Generally, about {this.getMappedPercent()}% of research expenditures can be matched to location information with available data and methodology.</p>
	            </div>
            </div>
        </div>
    }
}

export default withUserActionTracker(CongressTab, "Spending Report", "viewed Congressional District (Map) All");